import { Button, Modal, notification, Spin, Switch, Table } from 'antd'
import { useEffect, useRef, useState } from 'react'
import Styles from './index.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { editRole, getAreaEncryptStatus, getRoleList } from '../../common/request'
import ResponseCode from '../../common/response-code'
import { updateRoleList } from '../../store/slice/role-slice'
import UpdateAreaEncryptStatusModal from './UpdateAreaEncryptStatusModal'
import UpdateSecurityPasswordModal from './UpdateSecurityPasswordModal'

function SecurityManagement () {
  const updateSecurityPasswordModalRef = useRef(null)
  const updateAreaEncryptStatusModalRef = useRef(null)
  const dispatch = useDispatch()
  const [notifyApi, contextHolder] = notification.useNotification()
  const [areaEncryptStatus, setEncryptStatus] = useState(false)
  const [tableList, setTableList] = useState([])
  const roleList = useSelector(state => state.role.roleList)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getAreaEncryptStatusAction()
  }, [])

  useEffect(() => {
    setTableList(roleList)
  }, [roleList])

  const toggleRoleSecurity = (record, encryptStatus) => {
    editRoleAction(record, encryptStatus)
  }

  const securityTableColumn = [
    {
      title: '角色名称',
      key: 'name',
      dataIndex: 'name',
      width: 200
    },
    {
      title: '加密状态',
      key: 'encryptStatus',
      dataIndex: 'encryptStatus',
      render: (text, record) => {
        return (
          <Switch checked={ Boolean(record.encrypt) } checkedChildren="开启" unCheckedChildren="关闭" onChange={ toggleRoleSecurity.bind(this, record) }></Switch>
        )
      }
    },
    {
      title: '加密字段',
      key: 'fieldList',
      dataIndex: 'fieldList',
      render: () => {
        return <div>功能开发中···</div>
      }
    }
    // {
    //   title: '操作',
    //   key: 'operation',
    //   dataIndex: 'operation',
    //   render: (text, record) => {
    //     return <Button type="danger" ghost>删除</Button>
    //   }
    // }
  ]

  const updateRoleListAction = () => {
    setLoading(true)
    getRoleList().then(res => {
      if (res.code === ResponseCode.success && res.data) {
        dispatch(updateRoleList({ roleList: res.data }))
      } else {
        Modal.error({
          title: '错误',
          content: res.msg,
          centered: true
        })
      }
    }).catch(() => {
      Modal.error({
        title: '网络错误',
        content: '查询字典小类失败',
        centered: true
      })
      setTableList(roleList)
    }).finally(() => {
      setTimeout(() => {
        setLoading(false)
      }, 150)
    })
  }

  const editRoleAction = (roleInfo, encryptStatus) => {
    setLoading(true)
    const params = {
      ...roleInfo,
      encrypt: Number(encryptStatus)
    }

    delete params.authoritySet

    editRole(params).then(res => {
      if (res.code === ResponseCode.success) {
        notifyApi.success({
          message: '操作成功',
          description: `更新角色成功`
        })
        updateRoleListAction()
      } else {
        Modal.error({
          title: '错误',
          content: res.msg,
          centered: true
        })
      }
    }).catch(() => {
      Modal.error({
        title: '网络错误',
        content: '更新角色失败',
        centered: true
      })
      setTableList(roleList)
    }).finally(() => {
      setLoading(false)
    })
  }

  const getAreaEncryptStatusAction = () => {
    getAreaEncryptStatus().then(res => {
      if (res.code === ResponseCode.success) {
        setEncryptStatus(Boolean(res.data.status))
      } else {
        Modal.error({
          title: '错误',
          content: res.msg,
          centered: true
        })
      }
    })
  }

  const toggleAreaSecurity = () => {
    updateAreaEncryptStatusModalRef.current?.showModal(areaEncryptStatus)
  }

  const openUpdateAreaSecurityPwdModal = () => {
    updateSecurityPasswordModalRef.current?.showModal()
  }

  return (<div>
    <Spin spinning={ loading }>
      { contextHolder }
      <div className="d-flex justify-content-between">
        <div className="d-flex align-center">
          <div>区域加密：</div>
          <Switch checked={ areaEncryptStatus } checkedChildren="开启" unCheckedChildren="关闭" onChange={ toggleAreaSecurity }></Switch>
        </div>
        <Button type="primary" onClick={ openUpdateAreaSecurityPwdModal }>修改安全密码</Button>
      </div>

      <div>
        <div className={ Styles.formTitle }>加密角色列表</div>
        <Table dataSource={ tableList } rowKey={ (record) => record.id } columns={ securityTableColumn } pagination={ false }></Table>
      </div>
    </Spin>

    <UpdateAreaEncryptStatusModal ref={updateAreaEncryptStatusModalRef} onSuccess={ getAreaEncryptStatusAction }></UpdateAreaEncryptStatusModal>
    <UpdateSecurityPasswordModal ref={updateSecurityPasswordModalRef}></UpdateSecurityPasswordModal>
  </div>)
}

export default SecurityManagement
